// extracted by mini-css-extract-plugin
export default {"card":"CountDownCard_card__89rp-"};